(function () {
    'use strict';
 
    angular
        .module('app')
        .filter('cometes', cometes);

function cometes($sce){
    return function(msg, ambit) { 

    
        if(ambit != 4)
        	var img2 = ' <img src="/static/images/comillas.png" style="transform: rotateY(-180deg);margin-top:-13px;" align="right" /><br />';
        else 
        	var img2 ="";
        
        
        return $sce.trustAsHtml(msg+img2);
        

    };
}
})();
